const UseProtectedRoute = ({ children }) => {
  return children;
};

export default UseProtectedRoute;
